import { getPlayerSessionId } from "../../helpers";

async function sendResetLocalGameRequest(): Promise<void> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}player/game/reset`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
        });

        const result: any = await response.json();

        console.log(result);

        if (!result) {
            return;
        }

        return result.data;
    } catch (error) {
        console.error(error);
    }
    return;
}

export default sendResetLocalGameRequest;
